var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.listType === 'unordered')?_c('ul',{staticClass:"tw-list-none tw-text-gray-900 tw-bg-white tw-border tw-border-gray-200 tw-rounded-lg"},[_vm._t("default")],2):_c('ol',{staticClass:"tw-list-none tw-text-gray-900 tw-bg-white tw-border tw-border-gray-200 tw-rounded-lg"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }